import cached from 'utils/cached';
import { request } from 'utils/api';
import { joinPaths } from 'utils/utils';
import { getCurrentHubDomain } from 'utils/studioConfig';

const loadedAppDatas = new Map();

async function getThundrDataFromUrlRaw(url) {
	if (!url) return null;
	try {
		const lastBuild = await request(joinPaths(url, 'lastBuild.json'));
		loadedAppDatas.set(url, lastBuild.appData);
		return lastBuild.appData;
	} catch (err) {
		console.error('Error fetching Thundr data', err);
		return null;
	}
}
export const getThundrDataFromUrl = cached(getThundrDataFromUrlRaw, url => url);

function getMovieUrl(movie) {
	if (!movie?.thundr_id || movie.ready_state === 'none') return null;
	return `/${movie.ready_state === 'demo' ? 'demo-iframe' : 'prod-iframe'}/${movie.thundr_id}`;
}

export async function getThundrData(movie) {
	const url = getMovieUrl(movie);
	if (!url) return null;
	return getThundrDataFromUrl(url);
}

export function getSyncThundrDataIfAvailable(movie) {
	const url = getMovieUrl(movie);
	if (!url) return null;
	return loadedAppDatas.get(url);
}

export async function getHubThundrData() {
	const domainName = getCurrentHubDomain();
	if (!domainName) return null;
	return getThundrDataFromUrl(`https://${domainName}/`);
}

export function getStyleVariable(data, variableName) {
	return data?.styling?.variables[variableName];
}

export function getCopy(thundrData, name, defaultValue) {
	return thundrData?.copy?.baseCopy?.[name] || defaultValue;
}

export function getAccessibilityCopy(thundrData, name, defaultValue) {
	return thundrData?.copy?.accessibilityCopy?.[name] || defaultValue;
}

export function getPageName(thundrData, page, defaultValue) {
	const name = thundrData?.pages?.[page]?.name || defaultValue || page;
	return getCopy(thundrData, name) || getCopy(thundrData, `$PAGE_${page?.toUpperCase()}`) || name;
}

export function getThundrLink(movie) {
	if (!movie?.thundr_id || movie.ready_state === 'none') return null;
	return `http://localhost:4010/apps/edit/?app=${movie.thundr_id}`;
}